<template>
  <div class="flex items-center gap-3 p-3 border-b border-border hover:bg-primary/5 transition-colors">
    <!-- Product Icon -->
    <div class="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
      <img src="../../assets/major_tom/mt_icon.png"
           alt="Major Tom Icon"
           class="h-auto">
      <!--<i class="fas fa-headphones text-primary/60"></i>-->
    </div>

    <!-- Item Details -->
    <div class="flex-1 min-w-0">
      <h4 class="text-sm font-semibold text-foreground truncate">
        {{ item.productName || 'Unknown Product' }}
      </h4>
      <div class="flex items-center justify-between gap-2 text-xs text-muted-foreground">
        <span>{{ item.quantity }}x</span>
        <span class="font-semibold text-foreground">
          {{ formatCurrency((item.unitPrice || 0) * (item.quantity || 0)) }}
        </span>
      </div>
    </div>

    <!-- Delete Button -->
    <button class="flex-shrink-0 p-2 text-muted-foreground hover:text-accent transition-colors rounded-lg hover:bg-accent/10"
            aria-label="Delete item"
            @click="handleDelete">
      <font-awesome-icon :icon="['fas', 'trash-can']"
                         class="text-sm" />
    </button>
  </div>
</template>

<script setup lang="ts">
import type { ICartItemRequest, IProductRequest } from '@/data/_autogen/IValveVista';

const props = defineProps<{
  item: ICartItemRequest
  product: IProductRequest
}>();

const emit = defineEmits<{
  delete: [productId: number]
}>();

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

const handleDelete = () => {
  emit('delete', props.item.productId!);
};
</script>
